import {Loader} from '@mantine/core';
import {cn} from '../../../../../lib/classname';

type Props = {
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  filled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  children: React.ReactNode;
  className?: string;
};

export const InsideModalButton: React.FC<Props> = ({
  onClick,
  disabled = false,
  loading = false,
  filled = false,
  type = 'button',
  children,
  className,
}) => {
  return (
    <button
      type={type}
      className={cn(
        'text-base font-bold rounded-4 px-16 py-[6px] border-[1px] hover:opacity-80 flex justify-center items-start',
        {
          'border-background-2 bg-background-2 text-black-3 cursor-not-allowed':
            disabled,
          'border-primary bg-primary text-white': !disabled && filled,
          'border-primary bg-white text-primary': !disabled && !filled,
        },
        className,
      )}
      onClick={onClick}
      disabled={disabled}
    >
      {loading ? <Loader color="gray" size="xs" /> : children}
    </button>
  );
};
